import { defineComponent as _defineComponent } from 'vue'
import { centsToDollars } from '@/services/currency'
import { useReceiptQuery } from '@/features/tickets/api/queries'
import BKButton from '@/components/AppShared/BKButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseReceipt',
  props: {
    purchaseId: null,
    hideActions: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  purchaseId: number
  hideActions?: boolean
};





const { data: receipt, isLoading, error, refetch } = useReceiptQuery(props.purchaseId)

return { __sfc: true,props, emit, receipt, isLoading, error, refetch, centsToDollars, BKButton }
}

})